<script>
	import mapStyles from '../data/map-styles'; // optional
	import { onMount } from 'svelte';

	export let vcard;

	let container;
	let map;
	let zoom = 16;
	let center = {lat: -34.397, lng: 150.644};


	onMount(async () => {
		let mapa = await direccion(vcard.direccion);
		let lat = mapa.results[0].geometry.location.lat();
		let lng = mapa.results[0].geometry.location.lng();
		let center = {lat: lat, lng: lng};
		map = new google.maps.Map(container, {
			zoom,
			center,
			styles: mapStyles // optional
		});

		let marker = new google.maps.Marker({
			position: center,
			map: map
		});
	});
	const direccion = (address)=>{
		let geocoder = new google.maps.Geocoder();
		return geocoder.geocode({ 'address': address });
	}
</script>

<div class="full-screen" bind:this={container}></div>

<style lang="scss">
.full-screen {
	width: 100%;
	height: 100%;
}
</style>